const state = {
  listaEventTasks: [],
  eventTask: {
    id: null,
    evento: { id: null },
    titulo: '',
    descricao: '',
    responsavel: { id: null },
    dataPrevista: null,
    concluida: false,
    dataConclusao: null,
    ativo: true,
  },
}

export default state
